/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Letter_Spacing_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Letter Spacing" |
*
* @param {Styles_Letter_Spacing_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_letter_spacing_aria_label = /** @type {((inputs?: Styles_Letter_Spacing_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Letter_Spacing_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espacement des lettres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Buchstabenabstand")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spaziatura delle lettere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Межбуквенный интервал")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espaciado entre letras")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字母间距")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字間隔")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पत्र अंतराल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaçamento entre letras")
	return /** @type {LocalizedString} */ ("Letter Spacing")
});